import { useStore } from '@nanostores/react'
import { motion } from 'motion/react'
import { useState } from 'react'
import { ComparisonTable } from '~/components/comparison-table'
import { m } from '~/paraglide/messages'
import { platform } from '~/params'
import { $serviceLevelStatus } from '~/store/service-level-status'

export function ComparisonPage(props: {
  next: () => void
  // Starts the trial here instead of moving on (China Android). Handles its
  // own errors, so the promise only signals that the attempt has settled.
  onStartTrial?: () => Promise<void>
}) {
  const serviceLevelStatus = useStore($serviceLevelStatus)
  const isPremium = serviceLevelStatus?.is_premium ?? false
  // The CTA works once the page has finished appearing, then once per tap:
  // moving on leaves the page, but a trial attempt that ends without
  // subscribing (e.g. an aborted sign-in) keeps the user here, so the CTA
  // comes back when the attempt settles.
  const [isArmed, setIsArmed] = useState(false)

  const handleClick = async () => {
    setIsArmed(false)
    if (!props.onStartTrial) {
      props.next()
      return
    }
    try {
      await props.onStartTrial()
    } finally {
      setIsArmed(true)
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="relative h-full space-y-12 overflow-y-auto px-8 pb-52 pt-[120px]"
      onAnimationComplete={() => {
        setIsArmed(true)
      }}
    >
      <h1 className="whitespace-pre-line px-4 text-center text-2xl font-bold text-white">
        {isPremium
          ? m.subscription_walkthrough_p2_pro_title_2()
          : m.subscription_walkthrough_p2_free_title()}
      </h1>

      <ComparisonTable className="mx-auto max-w-[640px]" />

      <div
        className="fixed bottom-0 left-0 right-0 bg-[#001721] px-6 pb-12 pt-3"
        style={{
          boxShadow: '0 -3px 3px 0 rgba(255, 255, 255, 0.20)',
        }}
      >
        <div className="mx-auto max-w-[640px] space-y-3">
          <button
            className="group h-[52px] w-full rounded-xl p-px [background-image:linear-gradient(180deg,#C5FF70_0%,#69FF78_45%,#30D3FF_100%)]"
            disabled={!isArmed}
            onClick={handleClick}
          >
            <span className="flex h-full w-full items-center justify-center rounded-[11px] font-bold text-[#176361] [background-image:linear-gradient(106deg,#C5FF70_13%,#30D3FF_97%)] group-active:[background-image:linear-gradient(90deg,#94D66E_0%,#2BB8D3_100%)]">
              {platform === 'china_android'
                ? m.onboarding_paywall_start_triasl_btn_cna({
                    trial_day_number: 7,
                  })
                : m.btn_how_trial_works()}
            </span>
          </button>

          {platform === 'china_android' && (
            <p className="text-center text-xs text-white">
              {m.onboarding_paywall_footer_trial_cna()}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  )
}
